<template>
  <div class="container">
    <!-- <pre>
      {{ computedPageAuth }}
    </pre> -->
    <keep-alive>
      <router-view ref="container" :computedPageAuth="computedPageAuth" :methodAuthTabView="methodAuthTabView" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="container" :computedPageAuth="computedPageAuth" :methodAuthTabView="methodAuthTabView" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'container',
  props: ['routerKey'],
  data() {
    return {}
  },
  watch: {
    routerKey(val) {
      console.log('routerKey;', val)
    }
  },
  computed: {
    // 超管配置的alias一定要和当前路由name一致
  },
  mounted() {
    // window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    // 一定要在组件销毁前移除事件监听，避免内存泄露
    // window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    // handleBeforeUnload(event) {
    //   // 在这里编写你想要执行的逻辑
    //   // 例如，你可以显示一个确认对话框
    //   event.preventDefault()
    //   // event.returnValue = ''
    //   if (!this.computedPageAuth) {
    //     this.$router.push({
    //       name: this.$store.getters.permisionList[0].children[0].alias,
    //     })
    //   }
    //   return ''
    // },
    computedPageAuth(routeName) {
      // const permisionFirst = this.getPagePermision(
      //   this.$store.getters.permisionList,
      //   routeName || this.$route.name,
      //   'only'
      // )
      const permisionLast = this.getPagePermision(
        this.$store.getters.permisionList,
        routeName || this.$route.name,
        'all'
      )
      // console.log(
      //   'permisionFirst:--------------',
      //   permisionFirst,
      //   'permisionLast:---------------',
      //   permisionLast
      // )
      return permisionLast
    },
    methodAuthTabView(viewName, btnName, routeName) {
      // console.log(
      //   'this.computedPageAuth(routeName):',
      //   this.computedPageAuth(routeName)
      // )
      if (!this.computedPageAuth(routeName)) {
        return null
      }
      if (!btnName) {
        const someRs = this.getTargetBtn(
          this.computedPageAuth(routeName),
          viewName,
          btnName
        )
        return someRs
      } else {
        let findItem = null
        if (this.computedPageAuth(routeName)) {
          findItem = this.getTargetBtn(
            this.computedPageAuth(routeName),
            viewName,
            btnName
          )
        }
        if (findItem) {
          return findItem.userResource || null
        }
      }
    },
    getPagePermision(list, resultName, type) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (type === 'only') {
          if (
            item.alias.split(',').includes(resultName) &&
            item.children.length > 0
          ) {
            return item
          }
        }
        if (type === 'all') {
          if (item.alias.split(',').includes(resultName)) {
            return item
          }
        }
        const childResult = this.getPagePermision(
          item.children,
          resultName,
          type
        )
        if (childResult) {
          return childResult
        }
      }
      return null
    },
    getTargetBtn(topItem, viewName, btnName) {
      if (topItem.name === viewName) {
        if (!btnName) {
          return topItem
        } else {
          return topItem.children.find(
            (nodeItemBtn) => nodeItemBtn.name === btnName
          )
        }
      }
      for (let i = 0; i < topItem.children.length; i++) {
        const nodeItem = topItem.children[i]
        if (nodeItem.name === viewName) {
          if (!btnName) {
            return nodeItem
          } else {
            return nodeItem.children.find(
              (nodeItemBtn) => nodeItemBtn.name === btnName
            )
          }
        }
        if (nodeItem.children && nodeItem.children.length > 0) {
          const foundNodeItem = this.getTargetBtn(nodeItem, viewName, btnName)
          if (foundNodeItem) {
            return foundNodeItem
          }
        }
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  // overflow: auto;
  height: calc(100% - 60px);
}
</style>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
